<template>
    <div class="content">
        <table border="1" cellspacing="0">
            <colgroup>
                <col style="width:10%">
                <col style="width:12%">
                <col style="width:21%">
                <col style="width:22%">
                <col style="width:15%">
                <col style="width:20%">
            </colgroup>
            <tr>
                <td colspan="6" class="table-title">个人信息收集清单</td>
            </tr>
            <tr>
                <td>信息类型</td>
                <td>信息名称</td>
                <td>使用目的</td>
                <td>收集场景</td>
                <td>收集情况</td>
                <td>信息内容</td>
            </tr>
            <tr>
                <td rowspan="6">用户基本信息</td>
                <td>手机号</td>
                <td>用于注册创建账号，完善网络身份标识</td>
                <td>用户首次注册时主动输入</td>
                <td>收集1条</td>
                <td>133****1234</td>
            </tr>
            <tr>
                <td>电子邮箱</td>
                <td>1.用于注册创建账号；<br>2.修改已创建账号的密码；<br>3.注销账号时收取验证信息；</td>
                <td>用户首次注册账户时，或使用修改密码、注销账户功能时主动输入</td>
                <td>收集1条</td>
                <td>Todo***@163.com</td>
            </tr>
            <tr>
                <td>Apple ID</td>
                <td>用于创建都都会员账号，完善网络身份标识</td>
                <td>用户首次登录时主动提供（仅限于用户已授权给苹果）</td>
                <td>收集1条</td>
                <td>Appleid23de**********</td>
            </tr>
            <tr>
                <td>Google ID</td>
                <td>用于创建都都会员账号，完善网络身份标识</td>
                <td>用户首次登录时主动提供（仅限于用户已授权给谷歌）</td>
                <td>收集1条</td>
                <td>googleid23de**********</td>
            </tr>
            <tr>
                <td>昵称</td>
                <td>用于账号展示</td>
                <td>用户编辑信息自主输入</td>
                <td>收集1条</td>
                <td>都都</td>
            </tr>
            <tr>
                <td>出生年月</td>
                <td>用于创建使用者学习信息，对所选学习级别提供建议</td>
                <td>用户编辑信息自主输入</td>
                <td>收集1条</td>
                <td>2015-12</td>
            </tr>
            <tr>
                <td>设备信息</td>
                <td>硬件型号、操作系统类型、设备中的国家/地区、设备中的语言设置、设备ID（AndroidID）、IP、IDFA（仅限IOS）、Android ID（仅限安卓）</td>
                <td>用于排查产品使用问题，保障产品的安全和使用体验</td>
                <td>使用APP过程中APP收集</td>
                <td>收集1条</td>
                <td>BOE C20、Android、CN、zh、11*****-****-****-****-****C9、11*.1**.2**.**</td>
            </tr>
            <tr>
                <td rowspan="2">使用信息</td>
                <td>应用使用数据、使用等级、使用时间和频率、产品内玩过的游戏日志及结果、应用崩溃日志</td>
                <td>改善产品的使用功能，提升产品的使用体验</td>
                <td>使用APP过程中APP收集</td>
                <td>收集1条</td>
                <td>累计使用天数 **天，累计获得成果数量** 个</td>
            </tr>
            <tr>
                <td>语音内容</td>
                <td>通过收集使用者的语音内容，处理并完成产品内的跟读、发音测试。</td>
                <td>用户使用中主动输入</td>
                <td>仅使用不收集，不存储。</td>
                <td>-</td>
            </tr>
        </table>
    </div>
</template>
<script>

export default {
  name: 'privacyCollection',
}
</script>
<style src="@/assets/help/document.css" scoped></style>
